// assets/cart-discount-factor.js — v4.8 (shared doorType/category logic)
// Your Factor 放在 Export File 左邊；購物車為空時不顯示；清空後自動移除
// ★ 計算：單價(含選配) - No Glass Deduction -> * factor -> round 到 cents -> * qty
(function () {
  if (window.__CART_DISCOUNT_FACTOR_V48_SHARED__) return;
  window.__CART_DISCOUNT_FACTOR_V48_SHARED__ = true;

  /* ===== 基本參數 ===== */
  const LS_KEY = "cart_discount_factor_v1";
  const DEFAULT_FACTOR = 1.000, MIN_FACTOR = 0.000, MAX_FACTOR = 9.999, DECIMALS = 3;
  const LOCALE = document.documentElement.lang || "en-US";
  const CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
  const clamp = (n,a,b)=>Math.min(Math.max(n,a),b);
  const toFixedN = (n,d)=>Number(n).toFixed(d);

  function fmtMoney(cents){
    try {
      return new Intl.NumberFormat(LOCALE,{style:"currency",currency:CURRENCY})
        .format((cents||0)/100);
    } catch {
      return ((cents||0)/100).toFixed(2)+" "+CURRENCY;
    }
  }

  function loadFactor(){
    const n=parseFloat(localStorage.getItem(LS_KEY));
    return Number.isFinite(n)
      ? clamp(Number(toFixedN(n,DECIMALS)),MIN_FACTOR,MAX_FACTOR)
      : DEFAULT_FACTOR;
  }

  function saveFactor(n){
    localStorage.setItem(LS_KEY,String(Number(toFixedN(n,DECIMALS))));
  }

  async function fetchCart(){
    try{
      const r=await fetch("/cart.js?_="+Date.now(),{
        credentials:"same-origin",
        headers:{'Accept':'application/json','Cache-Control':'no-cache'}
      });
      return await r.json();
    }catch{
      return null;
    }
  }

  /* ===== cart.attributes Factor read/write ===== */
  function pickAttrFactor(attrs){
    attrs = attrs || {};
    return (
      attrs.Factor ??
      attrs.factor ??
      attrs.ND_FACTOR ??
      attrs.nd_factor ??
      attrs["Your Factor"] ??
      attrs["your factor"] ??
      ""
    );
  }

  function normalizeFactorValue(v){
    let n = parseFloat(String(v ?? "").trim());
    if (!Number.isFinite(n)) return null;
    n = clamp(Number(toFixedN(n,DECIMALS)), MIN_FACTOR, MAX_FACTOR);
    return n;
  }

  async function writeCartFactor(n){
    const val = toFixedN(n, DECIMALS);
    try{
      await fetch("/cart/update.js",{
        method:"POST",
        credentials:"same-origin",
        headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify({
          attributes: {
            "Factor": val,
            "factor": val,
            "ND_FACTOR": val,
            "nd_factor": val
          }
        })
      });
    }catch(e){
      console.warn("[ND_FACTOR] writeCartFactor failed", e);
    }
  }

  function isEmptyCart(cart){
    return !cart || !Array.isArray(cart.items) || cart.items.length===0;
  }

  /* ===== Shared No Glass helpers ===== */
  function getMap() {
    return window.NO_GLASS_DEDUCTION_MAP || {};
  }

  function buildDoorTypeCategoryMap() {
    const out = {};
    const map = getMap();

    Object.keys(map).forEach(category => {
      const categoryMap = map[category] || {};
      Object.keys(categoryMap).forEach(doorType => {
        out[doorType] = category;
      });
    });

    return out;
  }

  function getCategoryByDoorType(doorType) {
    return buildDoorTypeCategoryMap()[doorType] || '';
  }

  function normalizePanelType(raw){
    const text = String(raw || '').toLowerCase().trim();
    if (/full\s*view|full\s*lite/.test(text)) return 'full_lite';
    if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(text)) {
      return 'three_quarter_lite';
    }
    return '';
  }

  function normalizeDoorSize(raw){
    const text = String(raw || '').trim();
    const m = text.match(/\d{4,6}/);
    return m ? m[0] : '';
  }

  function normalizeDoorType(raw){
  const text = String(raw || '').toLowerCase().trim();

  // 先支援直接 doorType 值
  if (getCategoryByDoorType(text)) return text;

  // hinged
  if (/single[\s_-]*hinged/.test(text)) return 'single_hinged';
  if (/double[\s_-]*hinged/.test(text)) return 'double_hinged';
  if (/center[\s_-]*hinged/.test(text)) return 'center_hinged';
  if (/vented[\s_-]*sidelight|venting[\s_-]*sidelight/.test(text)) return 'vented_sidelight';

  // new hinged
  if (/folding\s*door|folding[\s_-]*door|^folding$/.test(text)) return 'folding';

  // gliding
  if (/gliding\s*door\s*-\s*2\s*panels|gliding[\s_-]*2[\s_-]*panel/.test(text)) return 'gliding_2_panel';
  if (/gliding\s*door\s*-\s*3\s*panels|gliding[\s_-]*3[\s_-]*panel/.test(text)) return 'gliding_3_panel';
  if (/gliding\s*door\s*-\s*4\s*panels|gliding[\s_-]*4[\s_-]*panel/.test(text)) return 'gliding_4_panel';

  // new gliding
  if (/bypass\s*gliding\s*door|bypass[\s_-]*gliding[\s_-]*door|gliding[\s_-]*bypass|bypass[\s_-]*gliding/.test(text)) {
    return 'gliding_bypass';
  }

  // fixed
  if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) return 'gliding_one_panel';
  if (/fixed\s*-\s*1\s*panel/.test(text)) return 'hinged_one_panel';
  if (/fixed\s*-\s*2\s*panels/.test(text)) return 'hinged_two_panel';
  if (/fixed\s*-\s*3\s*panels/.test(text)) return 'hinged_three_panel';

  return text || '';
}

  function normalizeCategory(raw){
    const text = String(raw || '').toLowerCase().trim();
    if (/hinged/.test(text)) return 'hinged';
    if (/gliding/.test(text)) return 'gliding';
    if (/fixed/.test(text)) return 'fixed';
    if (/transom/.test(text)) return 'transom';
    return text || '';
  }

  function isNoGlassValue(raw){
    return /no\s*glass/i.test(String(raw || ''));
  }

  function safeParseJson(str){
    if (!str) return {};
    try {
      return JSON.parse(str);
    } catch(e){
      return {};
    }
  }

  function getMergedItemProps(item){
    const rawProps = item?.properties || {};

    const bssRaw =
      rawProps.__bssCustomAttrs ||
      rawProps['__bssCustomAttrs'] ||
      rawProps['properties[__bssCustomAttrs]'] ||
      '';

    const bssAttrs = safeParseJson(bssRaw);

    return {
      ...rawProps,
      ...bssAttrs
    };
  }

  function getProp(props, keys){
    if (!props) return '';
    for (const key of keys) {
      if (props[key] != null && props[key] !== '') return props[key];
    }
    return '';
  }

  function detectDoorTypeFromItem(item, props){
    const direct = normalizeDoorType(
      getProp(props, [
        'No Glass Door Type',
        ' No Glass Door Type',
        'Door Type',
        ' Door Type'
      ])
    );
    if (direct) return direct;

    const title = String(item?.title || '').toLowerCase();
    const productTitle = String(item?.product_title || '').toLowerCase();
    const variantTitle = String(item?.variant_title || '').toLowerCase();
    const joined = `${title} ${productTitle} ${variantTitle}`;

    return normalizeDoorType(joined);
  }

  function getNoGlassDeductionCentsForItem(item){
    try{
      const props = getMergedItemProps(item);
      const doorType = detectDoorTypeFromItem(item, props);

      const category =
        normalizeCategory(getProp(props, [
          'No Glass Category',
          ' No Glass Category'
        ])) || getCategoryByDoorType(doorType);

      let size = normalizeDoorSize(getProp(props, [
        'No Glass Door Size',
        ' No Glass Door Size',
        'Door Size',
        ' Door Size'
      ]));

      let panelType = normalizePanelType(getProp(props, [
        'No Glass Panel Type',
        ' No Glass Panel Type',
        'Panel Type',
        ' Panel Type'
      ]));

      const noGlassSelected = getProp(props, [
        'No Glass Selected',
        ' No Glass Selected'
      ]);

      const noGlassDeductionRaw = getProp(props, [
        'No Glass Deduction',
        ' No Glass Deduction'
      ]);

      // 優先直接吃產品頁已算好的 deduction
      const directDeduction = parseFloat(String(noGlassDeductionRaw || '').replace(/[^0-9.-]/g, ''));
      if (/yes/i.test(String(noGlassSelected || '')) && Number.isFinite(directDeduction)) {
        return Math.round(Math.abs(directDeduction) * 100);
      }

      // 備援掃 size
      if (!size) {
        for (const k in props) {
          const joined = `${k} ${props[k] || ''}`;
          const m = String(joined).match(/\b\d{4,6}\b/);
          if (m) {
            size = m[0];
            break;
          }
        }
      }

      // 備援掃 panel type
      if (!panelType) {
        for (const k in props) {
          const joined = `${k} ${props[k] || ''}`;
          const normalized = normalizePanelType(joined);
          if (normalized) {
            panelType = normalized;
            break;
          }
        }
      }

      // 備援掃 no glass
      let glassValue = '';
      for (const k in props) {
        const joined = `${k} ${props[k] || ''}`;
        if (/glass option/i.test(joined) || /no\s*glass/i.test(joined)) {
          glassValue = joined;
          break;
        }
      }

      const hasNoGlass =
        /yes/i.test(String(noGlassSelected || '')) ||
        isNoGlassValue(glassValue);

      if (!hasNoGlass) return 0;
      if (!category || !doorType || !size || !panelType) return 0;

      const deductionDollars = Number(
        getMap()?.[category]?.[doorType]?.[size]?.[panelType] || 0
      );

      if (window.NO_GLASS_DEBUG_MODE) {
        console.log('[ND_FACTOR][NoGlass item]', {
          title: item?.title,
          props,
          category,
          doorType,
          size,
          panelType,
          deductionDollars
        });
      }

      return Math.round(deductionDollars * 100);
    }catch(e){
      console.warn('[ND_FACTOR] getNoGlassDeductionCentsForItem failed', e, item);
      return 0;
    }
  }

  function calcDiscountedTotalPerUnit(cart, factor){
    if (!cart || !Array.isArray(cart.items)) return 0;

    let sum = 0;

    for (const it of cart.items){
      const qty = Number(it?.quantity || 0);
      if (!qty) continue;

      const unitCents = Number(it?.final_price ?? it?.price ?? 0);
      const noGlassDeductionCents = getNoGlassDeductionCentsForItem(it);
      const netUnitCents = Math.max(0, unitCents - noGlassDeductionCents);
      const unitAfter = Math.round(netUnitCents * factor);

      sum += unitAfter * qty;
    }

    return sum;
  }

  function calcNetCartTotalBeforeFactor(cart){
    if (!cart || !Array.isArray(cart.items)) return 0;

    let sum = 0;

    for (const it of cart.items){
      const qty = Number(it?.quantity || 0);
      if (!qty) continue;

      const unitCents = Number(it?.final_price ?? it?.price ?? 0);
      const noGlassDeductionCents = getNoGlassDeductionCentsForItem(it);
      const netUnitCents = Math.max(0, unitCents - noGlassDeductionCents);

      sum += netUnitCents * qty;
    }

    return sum;
  }

  function updateEstimatedTotalDisplay(cents){
    const nodes = Array.from(document.querySelectorAll('*'));
    const labelNode = nodes.find(el =>
      Array.from(el.childNodes || []).some(
        n => n.nodeType === 3 && /Estimated total/i.test(n.textContent || '')
      )
    );

    if (!labelNode) return;

    const scope =
      labelNode.closest('.totals, .cart__footer, .cart__blocks, section, div') ||
      labelNode.parentElement;

    if (!scope) return;

    const moneyNodes = Array.from(scope.querySelectorAll('*')).filter(el => {
      const txt = (el.textContent || '').trim();
      return /\$\s*[\d,]+(\.\d{2})?/.test(txt) && !/Estimated Total After Factor/i.test(txt);
    });

    const target = moneyNodes[moneyNodes.length - 1];
    if (!target) return;

    target.textContent = `${fmtMoney(cents)} ${CURRENCY}`;
  }

  function parseMoneyToCents(text){
    if (!text) return 0;
    return Math.round(
      Number(text.replace(/[^0-9.-]/g, "")) * 100
    );
  }

  function getOptisAddonCentsFromItem(itemEl){
    const list = [];
    itemEl.querySelectorAll("*").forEach(el => {
      const t = el.textContent || "";
      if (!t.includes("(+")) return;

      const m = t.match(/\(\+\s*\$[\d,]+(\.\d+)?\)/);
      if (!m) return;

      list.push(parseMoneyToCents(m[0]));
    });
    return list;
  }

  /* ===== 定位元素 ===== */
  function findTotalsElement(){
    const hit = Array.from(document.querySelectorAll("*")).find(el =>
      Array.from(el.childNodes||[]).some(
        n=>n.nodeType===3 && /Estimated total/i.test(n.textContent||"")
      )
    );
    if (!hit) return null;
    return hit.closest(".totals, .cart__footer, .cart__blocks, section, div") || hit.parentElement;
  }

  function findDiscountRow(){
    const direct = document.querySelector(".cart__discounts, .cart__block--discount, .cart-discount");
    if (direct) return direct;

    const input = document.querySelector("input[placeholder*='discount' i]") ||
                  document.querySelector("input[name*='discount' i]");
    if (input) return input.closest("form, .field, .cart__discounts, .cart__block, .cart-discount, div");

    const apply = Array.from(document.querySelectorAll("button, a"))
      .find(el => /^\s*apply\s*$/i.test(el.textContent||""));
    if (apply) return apply.closest("form, .cart__discounts, .cart__block, .cart-discount, div");

    return null;
  }

  /* ===== UI：Factor 區 ===== */
  function ensureFactorLine(){
      if (!document.getElementById("nd-factor-detached-form")) {
      const detachedForm = document.createElement("form");
      detachedForm.id = "nd-factor-detached-form";
      detachedForm.style.display = "none";
      detachedForm.addEventListener("submit", function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }, true);
      document.body.appendChild(detachedForm);
    }
    const discountRow = findDiscountRow();
    const totalsEl    = findTotalsElement();
    const footer      = document.querySelector(".cart__footer, [data-cart-footer]");
    const mainForm    = document.querySelector("form[action*='/cart']");

    const exportBtn =
      document.getElementById("cx2-download-cart-pdf") ||
      document.getElementById("cx2-open-cart-html")   ||
      document.getElementById("cx2-download-pdf")     ||
      document.getElementById("download-cart-pdf");

    const btnRow = exportBtn && exportBtn.parentElement;

    const parentFallback =
      (discountRow && discountRow.parentElement) ||
      (totalsEl && totalsEl.parentElement) ||
      footer ||
      mainForm ||
      document.body;

    if (!btnRow && !parentFallback) return null;

    let wrapLine = document.getElementById("nd-factor-line");
    if (!wrapLine){
      wrapLine = document.createElement("div");
      wrapLine.id = "nd-factor-line";
      wrapLine.innerHTML = `
        <style>
          #nd-factor-line{
            margin-left:16px;
            margin-right:12px;
            order:-1;
            flex:0 0 auto;
          }
          #nd-factor-line .nd-right{
            display:flex;
            align-items:center;
            justify-content:flex-start;
            gap:6px;
            white-space:nowrap;
          }
          #nd-factor-line #nd-factor-label{
            font-weight:800 !important;
            font-size:1.15rem !important;
            letter-spacing:.1px;
          }
          #nd-factor-line #nd-factor-input{
            width:90px;
            padding:.35rem .5rem;
            border:1px solid #d0d0d0;
            border-radius:8px;
            font-variant-numeric: tabular-nums;
            font-size:1.15rem !important;
            text-align:right;
          }
          #nd-factor-line #nd-factor-input::-webkit-outer-spin-button,
          #nd-factor-line #nd-factor-input::-webkit-inner-spin-button{
            -webkit-appearance:none;
            margin:0;
          }
        </style>
        <div class="nd-right">
          <label id="nd-factor-label" for="nd-factor-input">Your Factor</label>
          <input id="nd-factor-input"
       type="text"
       inputmode="decimal"
       autocomplete="off"
       spellcheck="false"
       form="nd-factor-detached-form"
       placeholder="0.000"
       pattern="^[0-9]*\\.?[0-9]*$" />
        </div>
      `;
    }

    if (btnRow && exportBtn){
      if (wrapLine.parentElement !== btnRow || wrapLine.nextSibling !== exportBtn){
        btnRow.insertBefore(wrapLine, exportBtn);
      }
    }
    else if (discountRow && parentFallback){
      if (wrapLine.parentElement !== parentFallback || wrapLine.nextSibling !== discountRow){
        parentFallback.insertBefore(wrapLine, discountRow);
      }
    }
    else if (totalsEl && parentFallback){
      if (wrapLine.parentElement !== parentFallback || wrapLine.nextSibling !== totalsEl){
        parentFallback.insertBefore(wrapLine, totalsEl);
      }
    }
    else if (wrapLine.parentElement !== parentFallback){
      parentFallback.appendChild(wrapLine);
    }

    return wrapLine.querySelector("#nd-factor-input");
  }

  function removeFactorLine(){
    const el = document.getElementById("nd-factor-line");
    if (el && el.parentElement) el.parentElement.removeChild(el);
  }

  function hideDiscountRowHard(){
    if (!document.getElementById("nd-hide-discount-style")){
      const style=document.createElement("style");
      style.id="nd-hide-discount-style";
      style.textContent=`
        .cart__discounts, .cart__block--discount, .cart-discount,
        form[action*="discount" i],
        input[placeholder*="discount" i],
        input[name*="discount" i] {
          display:none !important;
          visibility:hidden !important;
          height:0 !important;
        }
      `;
      document.head.appendChild(style);
    }

    const row = findDiscountRow();
    if (row){
      row.style.setProperty("display","none","important");
      row.setAttribute("aria-hidden","true");
    }
  }

  /* ===== 底部結果卡 ===== */
  function mountResultBlockOutsideTotals(){
    const totalsEl=findTotalsElement();
    const host=document.createElement("div");
    host.id="nd-factor-result";
    host.innerHTML=`
      <style>
        #nd-factor-result{margin-top:16px}
        #nd-factor-result .nd-row{display:flex; justify-content:flex-end}
        #nd-factor-result .nd-card{max-width:600px; width:100%; padding:18px 20px; border-top:1px dashed #e5e5e5;}
        #nd-factor-result .nd-grid{display:grid; grid-template-columns:1fr auto; align-items:baseline; gap:12px 18px;}
        #nd-factor-result .nd-head{font-size:1.6rem !important; color:#333 !important; margin-bottom:8px !important; font-weight:800 !important;}
        #nd-factor-result .nd-val{font-weight:800 !important; font-size:2.0rem !important; letter-spacing:.2px;}
        #nd-factor-result .right{text-align:right}
        #nd-factor-result #nd-show-total::after{
          content:" ${CURRENCY}"; margin-left:.25rem; font-weight:800; font-size:.9em; opacity:.85;
        }
        @media (max-width: 640px){
          #nd-factor-result .nd-row{justify-content:stretch}
          #nd-factor-result .nd-card{max-width:100%}
          #nd-factor-result .nd-grid{grid-template-columns:1fr}
          #nd-factor-result .right{text-align:left}
        }
      </style>
      <div class="nd-row">
        <div class="nd-card">
          <div class="nd-grid nd-head">
            <div>Factor</div>
            <div class="right">Estimated Total After Factor</div>
          </div>
          <div class="nd-grid">
            <div id="nd-show-factor" class="nd-val">1.000</div>
            <div id="nd-show-total" class="nd-val right">$0.00</div>
          </div>
        </div>
      </div>
    `;
    if (totalsEl && totalsEl.insertAdjacentElement) totalsEl.insertAdjacentElement("afterend", host);
    else (document.querySelector(".cart__footer")||document.body).appendChild(host);

    return {
      host,
      showFactor:host.querySelector("#nd-show-factor"),
      showTotal:host.querySelector("#nd-show-total")
    };
  }

  function removeResultBlock(){
    const host = document.getElementById("nd-factor-result");
    if (host && host.parentElement) host.parentElement.removeChild(host);
  }

  /* ===== 主流程 ===== */
  let inputEl, showEls;
let _lastEmptyState = null;
let _busyCalc = false;

let _cachedCart = null;
let _cartFetchPromise = null;
let _lastSavedFactor = null;
let _commitTimer = null;
let _isCommitting = false;

async function refreshCartCache(force) {
  if (_cartFetchPromise && !force) return _cartFetchPromise;

  _cartFetchPromise = fetchCart()
    .then(cart => {
      _cachedCart = cart;
      return cart;
    })
    .finally(() => {
      _cartFetchPromise = null;
    });

  return _cartFetchPromise;
}

  function sanitizeToDecimal(str){
    str=String(str||"").replace(/[^0-9.]/g,"");
    const parts=str.split(".");
    if(parts.length>2){ str=parts.shift()+"."+parts.join(""); }
    if(str.startsWith(".")) str="0"+str;
    return str;
  }

  async function recalcAndRender(options = {}){
  if(!inputEl || !showEls) return;
  if (_busyCalc) return;

  _busyCalc = true;

  try{
    const raw = sanitizeToDecimal(inputEl.value);
    let n = parseFloat(raw);

    if(!Number.isFinite(n)) n = DEFAULT_FACTOR;

    n = clamp(Number(toFixedN(n, DECIMALS)), MIN_FACTOR, MAX_FACTOR);

    // 重點：Factor 輸入預覽時，不要每次 fetch /cart.js
    let cart = _cachedCart;

    if (!cart || options.forceCartFetch) {
      cart = await refreshCartCache(true);
    }

    const netBeforeFactor = calcNetCartTotalBeforeFactor(cart);
    const discounted = calcDiscountedTotalPerUnit(cart, n);

    updateEstimatedTotalDisplay(netBeforeFactor);

    showEls.showFactor.textContent = toFixedN(n, DECIMALS);
    showEls.showTotal.textContent = fmtMoney(discounted);
  } finally {
    _busyCalc = false;
  }
}

  function mountOrRemount(){
    const el = ensureFactorLine();
    if (el) inputEl = el;
    hideDiscountRowHard();
  }

  async function applyEmptyState(options = {}){
  const cart = await refreshCartCache(!!options.forceCartFetch);
    const empty = isEmptyCart(cart);

    if (_lastEmptyState === empty) return;
    _lastEmptyState = empty;

    if (empty){
      removeFactorLine();
      removeResultBlock();
      inputEl = null;
      showEls = null;
      return;
    }

    if (!showEls) showEls = mountResultBlockOutsideTotals();
    mountOrRemount();

    let v = null;
    try{
      const attrRaw = cart && cart.attributes ? pickAttrFactor(cart.attributes) : "";
      const attrN   = normalizeFactorValue(attrRaw);
      if (attrN != null){
        v = attrN;
        saveFactor(v);
      }
    }catch(_){}

    if (v == null) v = loadFactor();
    if (inputEl) inputEl.value = toFixedN(v,DECIMALS);

    recalcAndRender();
  }

  async function init(){
  await applyEmptyState();

  let previewTimer = null;
  let lastPreviewToken = 0;

  function getNormalizedFactorFromInput(){
    if(!inputEl) return DEFAULT_FACTOR;

    let n = parseFloat(sanitizeToDecimal(inputEl.value));
    if(!Number.isFinite(n)) n = DEFAULT_FACTOR;

    n = clamp(Number(toFixedN(n,DECIMALS)), MIN_FACTOR, MAX_FACTOR);
    return n;
  }

  function schedulePreview(){
    if(!inputEl) return;

    clearTimeout(previewTimer);
    const token = ++lastPreviewToken;

    previewTimer = setTimeout(async ()=>{
  if(!inputEl) return;
  if(token !== lastPreviewToken) return;

  // 只用 cached cart 預覽，不 fetch /cart.js
  await recalcAndRender();
}, 250);
  }

  function commit(){
  if(!inputEl) return;

  clearTimeout(previewTimer);
  clearTimeout(_commitTimer);
  lastPreviewToken++;

  _commitTimer = setTimeout(async function () {
    if(!inputEl) return;

    try {
      let n = getNormalizedFactorFromInput();
      const val = toFixedN(n, DECIMALS);

      inputEl.value = val;
      saveFactor(n);

      console.log("[ND_FACTOR] commit local only, no /cart/update.js:", val);

      // 只更新畫面，不寫 Shopify cart attributes
      await recalcAndRender();
    } catch (err) {
      console.warn("[ND_FACTOR] local commit failed:", err);
    }
  }, 250);
}

  function isFactorEvt(e){
    return !!(e && e.target && e.target.id === "nd-factor-input");
  }

  document.addEventListener("input", (e)=>{
    if (!isFactorEvt(e)) return;
    e.stopImmediatePropagation();
    e.stopPropagation();

    e.target.value = sanitizeToDecimal(e.target.value);

    // 不要每打一字就立刻重算，改成短暫 debounce 預覽
    schedulePreview();
  }, true);

  document.addEventListener("change", (e)=>{
    if (!isFactorEvt(e)) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    commit();
  }, true);

  document.addEventListener("blur", (e)=>{
    if (!isFactorEvt(e)) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    commit();
  }, true);

  document.addEventListener("keydown", e=>{
  if(e.key === "Enter" && e.target && e.target.id === "nd-factor-input"){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    commit();
    return false;
  }
}, true);

  const mo = new MutationObserver((mutations)=>{
  if (window.__ndFactorEmptyTick) return;

  const shouldCheck = mutations.some(m => {
    const target = m.target;
    if (!target || !target.closest) return false;

    // 忽略 Factor 自己造成的 DOM 更新，避免自己觸發自己
    if (
      target.closest("#nd-factor-line") ||
      target.closest("#nd-factor-result")
    ) {
      return false;
    }

    // 只在 cart item 區域變動時檢查空車，不要整個 body 都檢查
    return !!target.closest(
      "cart-items, #main-cart-items, .cart-items, .cart__items, .cart-item, form[action*='/cart']"
    );
  });

  if (!shouldCheck) return;

  window.__ndFactorEmptyTick = true;

  setTimeout(async ()=>{
    window.__ndFactorEmptyTick = false;

    if (showEls) mountOrRemount();

    // 只有 cart item DOM 真的變動，才重新抓 cart
    await applyEmptyState({ forceCartFetch: true });
  }, 400);
});

mo.observe(document.body, {
  childList: true,
  subtree: true
});

  window.addEventListener("cart:refresh", ()=>{
  applyEmptyState({ forceCartFetch: true });
}, {passive:true});

window.addEventListener("cart:updated", ()=>{
  applyEmptyState({ forceCartFetch: true });
}, {passive:true});
}

  window.getNoGlassDeductionCentsForItem = getNoGlassDeductionCentsForItem;
  window.calcNetCartTotalBeforeFactor = calcNetCartTotalBeforeFactor;
  window.calcDiscountedTotalPerUnit = calcDiscountedTotalPerUnit;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ()=>{ init(); }, { once:true });
  } else {
    init();
  }
})();
